import { ClientInfluencerAccountStats } from '../helpers';
import { Skeleton } from '@round/creatorbase-ui';
import styles from './Stats.module.css';
import { toDecimalPoint } from '@round/utils';
import { asMoneyWithoutZeros, formatNumberToKNotation } from 'helpers';
import { Currency } from '@round/api';
import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import { getAverageDraftTimeLabel } from 'Modules/Plans/CreatorSearch/utils/creatorSearchUtils';
import cn from 'classnames';

type Props = {
    stats: ClientInfluencerAccountStats | null;
    isLoading: boolean;
    className?: string;
};

const getStatsItems = (
    stats: ClientInfluencerAccountStats | null,
    getCurrencyById: (id: number | null | undefined) => Currency | undefined
) => {
    return [
        {
            label: 'Followers',
            value: stats?.followers ? formatNumberToKNotation(stats.followers) : '-',
        },
        {
            label: 'Engagement Rate',
            value: stats?.engagementRate ? `${toDecimalPoint(stats.engagementRate * 100, 2)}%` : '-',
        },
        {
            label: 'Average Views',
            value: stats?.averageViews ? formatNumberToKNotation(stats.averageViews) : '-',
        },
        {
            label: 'CPM',
            value: stats?.cpm ? asMoneyWithoutZeros(stats.cpm, getCurrencyById(stats.currencyId)) : '-',
        },
        {
            label: 'Average Draft Time',
            value: getAverageDraftTimeLabel(stats?.avgDraftTimeInHours),
        },
    ];
};

const Stats = ({ stats, isLoading, className }: Props) => {
    const { getCurrencyById } = useCurrencies();
    const statsItems = getStatsItems(stats, getCurrencyById);

    return (
        <div className={cn(styles.stats, className)}>
            {statsItems.map((item) => (
                <div key={item.label} className={styles.card}>
                    <p className={styles.title}>{item.label}</p>
                    <p className={styles.value}>
                        {isLoading ? <Skeleton className={styles.valueSkeleton} /> : item.value}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default Stats;
